import React from 'react'

const BoatingUsers = () => {
  return (
    <div>
       Users
    </div>
  )
}

export default BoatingUsers
